module.exports = __webpack_public_path__ + "img/4-2.fc2deda6.png";